import { g, highlighters, V, VElement } from "@clientio/rappid";
import { MARKER, WARNING_COLOR } from "./base/validation";
import { TransitionView } from "./transition";

export class LinkWarningsList extends highlighters.list {
  // list of colored ellipses
  createListItem(tooltip: string, { width, height }: { width: number; height: number }) {
    const itemNode: VElement = V("text", {
      y: height,
      x: width,
      fill: WARNING_COLOR,
      draggable: false,
      cursor: "pointer",
      opacity: 1,
    });
    itemNode.node.setAttribute("font-family", "FontAwesome");
    itemNode.text(MARKER);
    itemNode.node.setAttribute("data-tooltip", tooltip);
    itemNode.node.setAttribute("font-size", "13px");
    itemNode.node.setAttribute("text-anchor", "middle");
    itemNode.node.setAttribute("xml:space", "preserve");
    return itemNode.node;
  }

  position(link, listSize: { width: number; height: number }) {
    const { width, height }: { width: number; height: number } = listSize;
    const { x, y }: g.Point = (this.cellView as TransitionView).getPointAtRatio(0.5);
    this.vel.attr("transform", `translate(${x - width}, ${y - height})`);
  }
}
